import { ChangeEvent, useEffect, useState } from 'react'
import { Stack } from '@chakra-ui/react'

import { MaskedInput } from 'components/dataEntry'
import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import { ctpsMask } from 'utils/masks'
import { removeEverythingThatIsNotNumber } from 'utils/transforms/string'
import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import validateCTPSOnCustomForm from 'components/tools/CustomForm/components/Viewer/utils/validateCTPSOnCustomForm'
import useCustomFormGetDefaultValue from '../../../../hooks/useCustomFormGetDefaultValue'

export default function CustomFormCTPSQuestion({
  question,
  questionKey,
  disabled,
  formMethods,
}: CustomFormViewerQuestionProps) {
  const [ctpsNumber, setCTPSNumber] = useState<string>('')

  const { removeErrorFromQuestion, setErrorOnQuestion, thisQuestionHasError } = useCustomFormViewer()

  const questionWithError = thisQuestionHasError(question.slug)?.question

  async function handleOnChange(event: ChangeEvent<HTMLInputElement>) {
    const ctps = event.target.value
    setCTPSNumber(ctps)
    const errorMessage = validateCTPSOnCustomForm({ ctps, isRequired: question.is_required })
    if (errorMessage === '' && formMethods?.watch) {
      formMethods.setValue(questionKey, removeEverythingThatIsNotNumber(ctps))
      removeErrorFromQuestion(question.slug)
    } else {
      setErrorOnQuestion(question, errorMessage)
    }
  }

  const { defaultValue } = useCustomFormGetDefaultValue({ question, questionKey, disabled })

  useEffect(() => {
    const defaultCTPS = defaultValue
    if (defaultValue) {
      setCTPSNumber(defaultCTPS)
    }
    if (formMethods?.setValue) {
      formMethods.setValue(questionKey, defaultValue)
    }
  }, [defaultValue])

  return (
    <Stack>
      <MaskedInput
        id={question.slug}
        value={ctpsNumber}
        onChange={handleOnChange}
        mask={ctpsMask}
        isDisabled={disabled}
        placeholder={question?.placeholder}
      />

      <CustomFormFieldErrorMessage message={questionWithError?.error_message} />
    </Stack>
  )
}
